import {TypedUseSelectorHook, useSelector, useDispatch} from 'react-redux'
import {ThunkDispatch} from 'redux-thunk'
import {Action} from 'redux'
import {AppState} from 'store/types'

// Typed useSelector hook
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector

// Typed useDispatch hook
export type AppDispatch = ThunkDispatch<AppState, unknown, Action<string>>
export const useAppDispatch = () => useDispatch<AppDispatch>()

// Re-export types for convenience
export type {AppState} from 'store/types'
